import * as React from "react";

import { SettingsSection } from "constants/settings/sections";
import useSettingsSection from "hooks/settings/use-settings-section";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
export { default } from "./Router";

export const SettingsSectionMarker: React.FC<{ section: SettingsSection }> = ({ section }) => {
  useSettingsSection(section);
  return null;
};
